import React, {useCallback} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useSearchMgrInstance} from 'coreHooks';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';

import {useRefinementsContext} from '../FlyoutFilterContext';

import messages from './messages';

import styles from './FiltersRefinementActions.module.scss';

const FiltersRefinementActions = () => {
	const {managerRepository} = useGeneralProvider();
	const intl = useIntl();
	const {searchConfig} = useRefinementsContext();
	const searchMgr = useSearchMgrInstance({
		key: searchConfig.searchInstanceKey,
		searchType: searchConfig.searchType,
	});
	const searchModel = searchMgr.getStoredSearchModel();
	const totalResults = searchModel?.getTotalProductsNumber();
	const selectedFilters = searchModel?.getSelectedRefinementsValuesModels();
	const isResetButtonDisabled = !searchMgr?.isSomeFilterSelectedByUser() && !searchMgr?.getUserSelectedSorting();

	const handleCloseFilters = useCallback(() => {
		managerRepository.getFlyoutsMgr().closeFlyout('filters');
	}, []);

	const handleResetFilters = useCallback(() => {
		searchMgr.clearRefinements();
		searchMgr.search();
	}, []);

	return (
		<div className={styles['filter-actions']}>
			<Button
				onClick={handleResetFilters}
				classNames={cn(styles['filter-actions__btn'], styles['filter-actions__btn--reset'])}
				variant="primary-white"
			>
				{intl.formatMessage(messages.clearAll)}
			</Button>
			<Button
				onClick={handleCloseFilters}
				classNames={cn(styles['filter-actions__btn'], {
					[styles['filter-actions__btn--disabled']]: isResetButtonDisabled
				})}
				variant="primary"
			>
				{intl.formatMessage(messages.viewResults, {totalResults: selectedFilters.length ? totalResults : ''})}
			</Button>
		</div>
	);
};

export default FiltersRefinementActions;